import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import GuidePage from "../pages/guides/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pandabuy-sheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/guides/:slug",
    element: <GuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;